<template>
  <div>
    <Card class="cardDiv">
      <p slot="title">组织名称：{{currentData.organizationName}}</p>
      <Tree :data="treeData_select"></Tree>
    </Card>

   <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organizationData: {},
      treeData_select: [],
    };
  },

  created: function () {
    this.getListTreeById();
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    //获取该组织下的机构树
    getListTreeById() {
      let id = this.currentData.id;
      this.$api.get(`/organization/getListTreeById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.treeData_select = rsp.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.cardDiv {
  height: 400px;
  overflow: auto;
}
</style>